import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-alert",
	templateUrl: "./alert.component.html",
	styleUrls: ["./alert.component.scss"]
})
export class AlertComponent implements OnInit {
	@Input() level: "success" | "info" | "error" | "warning" = "warning";
	@Input() public title: string | null = null;
	@Input() neutral = false;
	@Input() border = false;
	@Input() icon: string | null = null;

	ngOnInit(): void {
		this.setIcon();
	}

	public setAlertClasses() {
		const classes = [`alert__body`];

		if (this.border) {
			const level = this.neutral ? "neutral" : this.level;
			classes.push(`${level}-border-100`);
			classes.push(`border-hairline`);
		}

		if (this.neutral) {
			classes.push(`neutral-border-100`);
			classes.push(`neutral-bg-50`);
			classes.push(`neutral-700`);

			return classes;
		}

		classes.push(`${this.level}-bg-50`);
		classes.push(`${this.level}-800`);

		return classes;
	}

	public setAlertTitleClasses() {
		const level = this.neutral ? "neutral" : this.level;
		return [`${level}-800`];
	}

	public setIcon() {
		if (this.icon) return;

		const levelIcons = {
			success: "check_circle",
			info: "info",
			error: "cancel",
			warning: "warning"
		};

		this.icon = levelIcons[this.level];
	}

	public setIconClasses() {
		const step = this.neutral ? "500" : "800";
		return [this.icon, `${this.level}-${step}`];
	}
}
